<template>
  <el-container style="height: 100%">
    <layout-sider />
    <el-container direction="vertical">
      <layout-header />
      <layout-main />
      <layout-footer />
    </el-container>
    <label-task-info v-if="userPermission.OPERATE" />
  </el-container>
</template>
<script>
import LayoutHeader from '../components/layout/layout-header.vue'
import LayoutSider from '../components/layout/layout-sider.vue'
import LayoutMain from '../components/layout/layout-main.vue'
import LayoutFooter from '../components/layout/layout-footer.vue'
import LabelTaskInfo from '@/components/label-task-info/label-task-info.vue'
import { mapState } from 'vuex'
export default {
  name: 'index',
  components: { LayoutHeader, LayoutSider, LayoutMain, LayoutFooter, LabelTaskInfo },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userPermission: state => state.account.permission
    })
  }
}
</script>
